import React from 'react';
import { isMobile } from 'react-device-detect';
import { Routes, Route } from 'react-router-dom';
import Box from '@mui/material/Box';
import AvatarChat from '../components/AvatarStatic/AvatarChat';
import ResetPassword from '../pages/ResetPassword';
import ContactsPage from '../pages/ContactsPage';
import AvatarPage from '../pages/AvatarPage';
import PrivateProfilPage from '../pages/PrivateProfilPage';
import HomePage from '../pages/HomePage';
import TestPage from '../pages/TestPage';
import PayPage from '../pages/PayPage';
import AdminPage from '../pages/AdminPage/AdminPage';





export default function Main( { open, isSmall } ) {
  return (
    <div style={{ 
        // height: 'calc(100dvh + 60px)',
        top: '60px',
        height: 'calc(100dvh - 60px)',
        width: !isSmall?'calc(100vw - 65px)':'100vw', 
        // top: '60px',
        placeontent: 'center',
        position: 'absolute', 
        alignItems: 'center', 
        // display: 'flex', 
        justifyContent: 'bottom', 
        placeContent: 'center',
        overflow: 'hidden', 
        position: 'relative'}}>
        <Routes>
          <Route path="/:id" element={<AvatarPage />} />
          <Route path="/" element={<AvatarPage />} />
          <Route path="/reset_password/:token" element={<ResetPassword />} />
          <Route path='/contacts' element={<ContactsPage />} />
          <Route path='/donate' element={<PayPage />} />
          <Route path='/profil' element={<PrivateProfilPage />} />
          <Route path='/home' element={<HomePage />} />
          <Route path='/contact' element={<TestPage />} />
          <Route path='/admin123456789' element={<AdminPage />} />
        </Routes>
    </div>
  );
}
// [EOD]
